import { useEffect, useRef } from 'react';

export const useSelectFirstItemAfterUpdateDynamicList = (
    data: any,
    listName: string,
    onSelect?: (value: string, data: any) => void,
) => {
    const isUpdateFirstVersionAfterUpdate = useRef<number>(0);

    useEffect(() => {
        if (onSelect) {
            isUpdateFirstVersionAfterUpdate.current = 3;
        }
    }, []);

    useEffect(() => {
        if (onSelect) {
            if (isUpdateFirstVersionAfterUpdate.current === 1 && data?.[listName].edges[0].node.__id) {
                setTimeout(() => onSelect?.(data?.[listName].edges[0].node.__id, data?.[listName]));
                isUpdateFirstVersionAfterUpdate.current = 0;
            }

            if (isUpdateFirstVersionAfterUpdate.current > 1) {
                isUpdateFirstVersionAfterUpdate.current--;
            }
        }
    }, [data]);

    return true;
};
